if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');


      const mainVariantId = this.form
        ? this.form.querySelector('[name="id"]').value
        : this.querySelector('[name="id"]').value;
      const quantityInput = this.form?.querySelector('[name="quantity"]') || this.querySelector('[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      const accessoryInputs = this.parentElement.parentElement.querySelectorAll('.yg-accessory-item input[type="checkbox"]:checked') || document.querySelectorAll('.yg-accessory-item input[type="checkbox"]:checked');
      const accessoryItems = Array.from(accessoryInputs).map(input => ({
        id: input.dataset.id,
        quantity: quantity
      }));

      const items = [
        { id: mainVariantId, quantity: quantity },
        ...accessoryItems
      ];

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      if (this.cart) {
        config.body = JSON.stringify({
          items,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });

        this.cart.setActiveElement(document.activeElement);
      } else {
        config.body = JSON.stringify({ items });
      }

      // const config = fetchConfig('javascript');
      // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // delete config.headers['Content-Type'];

      // const formData = new FormData(this.form);
      // if (!this.form) {
      //   formData.append('id', this.querySelector('[name=id]').value);
      // }

      // if (this.cart) {
      //   formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      //   formData.append('sections_url', window.location.pathname);
      //   this.cart.setActiveElement(document.activeElement);
      // }
      // config.body = formData;

      // fetch(`${routes.cart_add_url}`, config)
      //   .then((response) => response.json())
      //   .then((response) => {
      //     if (response.status) {
      //       publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
      //       this.handleErrorMessage(response.description);
      //       const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //       if (!soldOutMessage) return;
      //       this.submitButton.setAttribute('aria-disabled', true);
      //       this.submitButton.querySelector('span').classList.add('hidden');
      //       soldOutMessage.classList.remove('hidden');
      //       this.error = true;
      //       return;
      //     } else if (!this.cart) {
      //       window.location = window.routes.cart_url;
      //       return;
      //     }

      //     if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
      //     this.error = false;
      //     const quickAddModal = this.closest('quick-add-modal');
      //     if (quickAddModal) {
      //       document.body.addEventListener('modalClosed', () => {
      //         setTimeout(() => { this.cart.renderContents(response) });
      //       }, { once: true });
      //       quickAddModal.hide(true);
      //     } else {
      //       this.cart.renderContents(response);
      //     }
      //   })
      //   .catch((e) => {
      //     console.error(e);
      //   })
      //   .finally(() => {
      //     this.submitButton.classList.remove('loading');
      //     if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //     if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //     this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      //   });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: mainVariantId, errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: mainVariantId });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
